import { NextRouter, withRouter } from 'next/router';
import React, { ErrorInfo, ReactNode } from 'react';
import ErrorHandler from './ErrorHandler';

interface WithRouterProps {
    router: NextRouter;
}
type Props = { children: ReactNode } & WithRouterProps;

type State = { hasError: boolean };

export class ErrorBoundary extends React.Component<Props, State> {
    state: State = { hasError: false };
    constructor(props: Props) {
        super(props);
        this.state = { hasError: false };
    }
    static getDerivedStateFromError(error: unknown) {
        // Update state so the next render will show the fallback UI
        console.log(error);
        return { hasError: true };
    }
    componentDidCatch(error: Error, errorInfo: ErrorInfo) {
        // You can use your own error logging service here
        console.log(error, errorInfo.componentStack);
    }
    handleError = (errEvent: ErrorEvent) => {
        console.log(errEvent);
        this.setState({ hasError: true });
    };
    handleRejection = (rejectEvent: PromiseRejectionEvent) => {
        console.log(rejectEvent);
        this.setState({ hasError: true });
    };

    render() {
        // Check if the error is thrown
        if (this.state.hasError) {
            // You can render any custom fallback UI
            return <ErrorHandler></ErrorHandler>;
        }

        // Return children components in case of no error
        return this.props.children;
    }
}

export default withRouter(ErrorBoundary);
